import { useCallback, useEffect, useRef, useState } from 'react'
import Header from '../Header/Header.js';
import SideBar from './SideBar.js';
import { BsBox } from 'react-icons/bs';
import Select from "react-select";
import { FiDownload, FiFilter, FiX } from "react-icons/fi";
import { FaChevronDown, FaSyncAlt } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import Table from "../components/Table/index.jsx";
import { orderTableColumns } from '../components/Constant/index.js';
import CustomLabel from '../Common/CustomLabel.js';
import SpinLoader from '../components/SpinLoader.js';
import { GET_ORDER_COUNT, GET_ORDERS } from '../graphql/Query/Order.js';
import { useLazyQuery, useQuery } from '@apollo/client';
import jsPDF from 'jspdf';
import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { typeOptions } from '../DomesticSellerOrder/AllOrderSeller.js';
import DateFilter from '../Common/DateRange.js';
import { toast } from 'react-toastify';
import { getDateRange } from '../Common/GetDateRange.js';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const CreatShiment = [
    { value: "Single Shipment", label: "Single Shipment", link: "/documentshipping" },
    // { value: "bulk Shipment", label: "Bulk Shipment", link: " /bulkcourier" },
];

const DashShipment = () => {

    // console.log('✌️finalRange --->', finalRange);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const awbFromURL = searchParams.get("awb");  // Get AWB from URL
    const [showFilters, setShowFilters] = useState(true);
    const [isOpen, setIsOpen] = useState();
    const [toggleCleared, settoggleCleared] = useState(false);
    const [multipleId, setMultipleId] = useState([]);
    const invoiceRef = useRef(null);
    const [activeTab, setActiveTab] = useState("All");
    const [selectedMoreOption, setSelectedMoreOption] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sort, setSort] = useState({ key: "createdAt", type: -1 });
    const [orderData, setOrderData] = useState([]);
    // console.log('✌️orderData --->', orderData);
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState(awbFromURL);
    // console.log('✌️orderData --->', orderData);
    const [loadingData, setLoading] = useState(false);
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [finalRange, setFinalRange] = useState({
        filterType: awbFromURL ? "Life Time" : "Last 7 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [fromDate, setFromDate] = useState('');
    const [selectedCheckBox, setSelectedCheckBox] = useState();
    const handleTabClick = (tab) => {
        console.log('✌️tab --->', tab);
        setActiveTab(tab);
        handleClear();
        if (tab === 'All') {
            setorderStatus('');
        } else if (tab === 'Cancelled') {
            setorderStatus('Cancelled');
        } else if (tab === 'Pickup Done') {
            setorderStatus('Pickup Done');
        } else if (tab === 'In Transit') {
            setorderStatus('In Transit');
        } else if (tab === 'Out for Delivery') {
            setorderStatus('Out for Delivery');
        } else if (tab === 'Delivered') {
            setorderStatus('Delivered');
        } else if (tab === 'RTO') {
            setorderStatus('RTO');
        } else if (tab === 'RTO Delivered') {
            setorderStatus('RTO Delivered');
        } else if (tab === 'Booked') {
            setorderStatus('Booked');
        } else if (tab === 'Reached at Destination') {
            setorderStatus('Reached at Destination');
        } else if (tab === 'Exception') {
            setorderStatus('Exception');
        } else if (tab === 'Pending RTO') {
            setorderStatus('Pending RTO');
        } else if (tab === 'RTO Reached at Destination') {
            setorderStatus('RTO Reached at Destination');
        } else if (tab === 'Misrouted') {
            setorderStatus('Misrouted');
        } else if (tab === 'RTO In Transit') {
            setorderStatus('RTO In Transit');
        } else {
            setorderStatus('');
        }
        refetchCount()
        setSelectedMoreOption("");
    };
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [filter, setFilter] = useState('');
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_ORDERS, {
        variables: {
            page: page,
            limit,
            "sort": sort,
            tag: 'All Courier',
            "filter": awbNumber ? awbNumber?.trim() : filter?.trim(),
            from: finalRange?.startDate?.toISOString(),
            to: finalRange?.endDate?.toISOString(),
            orderStatus: orderStatus,
            paymentStatus: selectedPaymentType,
        },
        fetchPolicy: 'cache-and-network',
    });
    const [fetchAllOrders] = useLazyQuery(GET_ORDERS, {
        fetchPolicy: "cache-and-network"
    });

    const { data: countData, refetch: refetchCount } = useQuery(GET_ORDER_COUNT, {
        variables: {
            tag: 'All Courier',
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(),
            to: finalRange?.endDate?.toISOString(),
            paymentType: selectedPaymentType
        },
        fetchPolicy: "cache-and-network",
    })
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);
    const [singleOrder, setSingleOrder] = useState();
    // console.log('✌️singleOrder --->', singleOrder);
    const [singleOrderLabel, setSingleOrderLabel] = useState();
    useEffect(() => {
        if (GetOrderOrder?.getOrders?.data) {
            setOrderData(GetOrderOrder?.getOrders?.data);
        }
    }, [GetOrderOrder]);



    const handleDropdownSelect = (option) => {
        setSelectedMoreOption(option);
        setActiveTab(option); // Highlight active tab from dropdown
        setIsOpen(false);
        setorderStatus(option)
    };

    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);

        handleClear();
    }
    const handleClear = () => {
        settoggleCleared(!toggleCleared);
        setSelectedCheckBox()
        setMultipleId([]);

    }


    const options = [
        "Pending RTO",
        "RTO",
        // "RTO Delivered",
        // "RTO Lost",
        // "RTO Damaged",
        "RTO In Transit",
        "RTO Reached at Destination",
        "RTO Delivered",
        "Misrouted",
        "Exception",
        "Lost",
        "Damaged",
    ];
    const navigate = useNavigate();
    const handleChange = (selectedOption) => {
        if (selectedOption?.link) {
            navigate(selectedOption?.link.trim(), { replace: true });
        }
    };

    const handleBulkLabelDownload = async () => {
        if (!multipleId || multipleId.length === 0) return;
        setLoading(true);

        const doc = new jsPDF("p", "pt", [285, 437]);
        let allowedLabelCount = 0;

        const loadFonts = async () => {
            if (document.fonts) {
                await document.fonts.ready;
            }
        };

        for (let i = 0; i < multipleId.length; i++) {
            const order = multipleId[i];
            if (!order) continue;


            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-9999px";
            document.body.appendChild(container);

            const root = createRoot(container);
            root.render(<CustomLabel key={order.order_id} order={order} />);

            await loadFonts(); // Wait for fonts to load
            await new Promise((resolve) => setTimeout(resolve, 600));

            try {
                const canvas = await html2canvas(container, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: null,
                    logging: false,
                });

                const imgData = canvas.toDataURL("image/png");
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                if (allowedLabelCount > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                allowedLabelCount++;
            } catch (error) {
                console.error("Error generating label:", error);
            }

            root.unmount();
            document.body.removeChild(container);

        }

        if (allowedLabelCount > 0) {
            doc.save("bulk_labels.pdf");
        }

        setLoading(false);
        setMultipleId([]);
        handleClear();
    };



    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index + 1,
                // "Order ID": shipment?.order_id,
                "Order Number": shipment?.order_number,
                "Shipment Date": moment(shipment?.createdAt).format('DD/MM/YYYY'),
                "COD Collectable Amount.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "Payment": shipment?.ProductPrice,
                "Payment Mode": shipment?.payment_type,
                "AWB Number": shipment?.awb_number,
                "Customer Name": shipment?.deliveryAddress?.name,
                "Phone Number": shipment?.deliveryAddress?.phone,
                "Alternate Phone Number": shipment?.deliveryAddress?.alternateMobileNumber,
                Address: fullAddress,
                City: city,
                State: state,
                "Zip Code": zipCode,
                "Tracking Status": shipment?.status,
                "Delivery Date": shipment?.delivery_order_Date,
                "Weight (Kg)": shipment?.package_weight,
                Product: shipment?.ProductName,


                // "COD Collection Rs.": `${shipment?.codCollectableValue}`,
                // "Shipment Charge": `₹${shipment?.order_amount}`,
                // // "phone":demoo,
                // "RTO Charges": `${shipment?.rto_order_charge || 0}`,
                // "Total Amount": `${shipment?.final_order_amount || 0}`,
            };
        });
    };
    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: 1,
                limit: 100000,
                "sort": sort,
                tag: 'All Courier',
                "filter": filter.trim(),
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),
                orderStatus: orderStatus,
                paymentStatus: selectedPaymentType,
            },
            fetchPolicy: "cache-and-network"
        });

        if (!data?.getOrders?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getOrders?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "shipments.xlsx");
    };

    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };

    const resetData = () => {
        setPage(1);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedPaymentType('');
        setActiveTab('All');
        handleClear();
        const defaultRange = getDateRange("Last 7 Days");
        setFinalRange({
            filterType: "Last 7 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 7 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

    }
    const onSelectedRowsChange = (data) => {
        if (data?.selectedCount > 0) {
            const Ids = data?.selectedRows?.map((d) => d)
            // console.log('✌️Ids --->', Ids);
            setMultipleId(Ids)
            setSelectedCheckBox(data?.selectedCount)
        } else {
            handleClear();
        }
    }

    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}
                <SideBar />

                {/* Main Content */}
                <div className="flex-1 space-y-3 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <div className="bg-slate-100">
                        <div className="p-6 bg-white border rounded-lg space-y-6">
                            {/* Header Section */}
                            <div className="flex flex-col md:flex-row items-center justify-between gap-3 w-full">
                                <h1 className="text-xl font-bold text-left w-full md:w-auto">Shipments</h1>
                                <div className="w-full sm:w-60 md:w-40">
                                    <Select
                                        options={CreatShiment}
                                        classNamePrefix="react-select"
                                        placeholder="Create Order"
                                        onChange={handleChange}
                                        isSearchable={false}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                height: "36px", // Adjust height for better visibility
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                borderRadius: "8px",
                                                border: "1px solid #dbdbdb",
                                                "&:hover": { border: "1px solid #c9c9c9" },
                                                boxShadow: "none",
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: "#000",
                                                fontWeight: "500",
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                padding: "4px 0",
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                color: "#000",
                                                padding: "6px 12px",
                                                cursor: "pointer",
                                                backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                "&:hover": { backgroundColor: "#f0f0f0" },
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                color: "#000",
                                                "&:hover": { color: "#000" },
                                            }),
                                            indicatorSeparator: () => ({
                                                display: "none",
                                            }),
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 w-full">
                                {/* Title & Icon Section */}
                                <div className='md:block hidden'>
                                    <div className="flex items-center gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div></div>
                                <div className='block md:hidden'>
                                    <div className="flex gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl hidden md:block text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 md:text-left">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div>
                                </div>
                                {/* Button Section */}
                                <div className="flex flex-col sm:flex-row flex-wrap justify-Start lg:justify-end gap-3 w-full">
                                    <button
                                        onClick={() => window.location.reload()}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        <FaSyncAlt /> Refresh
                                    </button>
                                    <button
                                        onClick={downloadExcel}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        <FiDownload className="text-lg" />
                                        Export
                                    </button>
                                    <button
                                        onClick={() => setShowFilters(!showFilters)}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                        {showFilters ? "Close" : "Filter"}
                                    </button>
                                </div>
                            </div>

                            {/* Filter Section */}
                            {showFilters && (
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                    {/* Search Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Custom Search</label>
                                        <input
                                            type="text"
                                            value={searchUser}
                                            onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                                            // onKeyDown={handleSearch}
                                            placeholder="Search..."
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>


                                    {/* Order IDs */}
                                    {/* <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Customer
                                        </label>
                                        <input
                                            type="text"
                                            value={filterOrder}
                                            onChange={(e) => { setFilterOrder(e.target.value); handleSearch(e, 'orderId') }}                                     // onKeyDown={() => handleSearch('orderId')}
                                            placeholder="Customer Name"
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div> */}

                                    {/* AWB Numbers */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            AWB No.
                                        </label>
                                        <input
                                            type="text"
                                            value={awbNumber}
                                            onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                            placeholder="AWB Nos (comma-separated)"
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* Type Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                                        <Select
                                            options={typeOptions}
                                            defaultValue={typeOptions[0]}
                                            className="w-full"
                                            onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                            classNamePrefix="react-select"
                                            isSearchable={false}
                                            value={typeOptions.find(option => option?.value === selectedPaymentType) || null}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                    '&:hover': { borderColor: '#64748B' },
                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                    borderRadius: '0.375rem',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                    color: state.isSelected ? '#000000' : '#000000',
                                                    fontSize: '0.875rem',
                                                    '&:hover': {
                                                        backgroundColor: '#cbd5e1',
                                                        color: '#000000',
                                                        fontSize: '0.875rem',
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '14px',
                                                    color: '#A3AAB5',
                                                    fontSize: '0.875rem',
                                                }),
                                            }}
                                        />
                                    </div>


                                    {/* Date Filters */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                        <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />

                                    </div>

                                    <div className="flex items-end h-full" onClick={resetData}>
                                        <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                            Reset Filters
                                        </p>
                                    </div>
                                </div>
                            )}
                            {/* Tab Section */}
                            <div className="border-t">
                                <div className="flex flex-wrap gap-4 mt-6">
                                    {[
                                        { name: "All" },
                                        { name: "Pickup Done", count: countData?.getOrderStatusCounts?.statusCounts?.PickupDone || 0 },
                                        { name: "Booked", count: countData?.getOrderStatusCounts?.statusCounts?.Booked || 0 },
                                        { name: "In Transit", count: countData?.getOrderStatusCounts?.statusCounts?.InTransit || 0 },
                                        { name: "Reached at Destination", count: countData?.getOrderStatusCounts?.statusCounts?.ReachedatDestination || 0 },
                                        { name: "Out for Delivery", count: countData?.getOrderStatusCounts?.statusCounts?.OutforDelivery || 0 },
                                        { name: "Delivered", count: countData?.getOrderStatusCounts?.statusCounts?.Delivered || 0 },
                                        { name: "Cancelled", count: countData?.getOrderStatusCounts?.statusCounts?.Cancelled || 0 },
                                    ].map(({ name, count }) => (
                                        <button key={name} onClick={() => handleTabClick(name)}
                                            className={`px-4 py-1 text-sm shadow-md font-medium rounded-md ${activeTab === name ? "bg-slate-900 text-white" : "bg-white text-gray-700 border border-gray-300 hover:bg-slate-100"
                                                }`}>
                                            {name} {name === 'All' ? "" : `(${count})`}
                                        </button>
                                    ))}

                                    <div className="relative inline-block text-left ">

                                        <div className="relative inline-block text-left">
                                            <button
                                                onClick={() => setIsOpen(!isOpen)}
                                                className={`flex items-center justify-between px-4 py-1 shadow-md text-sm font-medium rounded-lg transition border ${selectedMoreOption ? "bg-slate-900 text-white border-slate-900" : "bg-white text-gray-700 border-gray-300 hover:bg-slate-100"
                                                    }`}
                                            >
                                                {selectedMoreOption || "More"} <FaChevronDown className="ml-2 text-xs" />
                                            </button>


                                            {isOpen && (
                                                <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg max-h-20 overflow-y-auto">
                                                    <ul className="py-2">
                                                        {options?.map((option, index) => (
                                                            <li
                                                                key={index}
                                                                className="px-4 py-2 text-gray-700 hover:bg-slate-100 cursor-pointer"
                                                                onClick={() => handleDropdownSelect(option)}
                                                            >
                                                                {option}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {/* <div className="relative inline-block text-left ">
                                  
                                        <div className="relative inline-block text-left">
                                            <button
                                                onClick={() => setIsOpen(!isOpen)}
                                                className={`flex items-center justify-between px-4 py-1 shadow-md text-sm font-medium rounded-lg transition border ${selectedMoreOption ? "bg-slate-900 text-white border-slate-900" : "bg-white text-gray-700 border-gray-300 hover:bg-slate-100"
                                                    }`}
                                            >
                                                {selectedMoreOption || "More"} <FaChevronDown className="ml-2 text-xs" />
                                            </button>

                                     
                                            {isOpen && (
                                                <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg ">
                                                    <ul className="py-2">
                                                        {options?.map((option, index) => (
                                                            <li
                                                                key={index}
                                                                className="px-4 py-2 text-gray-700 hover:bg-slate-100 cursor-pointer"
                                                                onClick={() => handleDropdownSelect(option)}
                                                            >
                                                                {option}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div> */}
                                </div>

                            </div>


                        </div>
                        <div className="flex mt-3 bg-white flex-wrap items-center gap-2 p-2 border border-gray-300 rounded-lg   w-full">
                            {/* Selected Count */}
                            <div className="px-4 py-1 border shadow-md rounded-lg border-slate-600 hover:bg-slate-200 transition text-gray-900 font-semibold text-sm flex items-center">
                                <span className="text-sm">{selectedCheckBox}</span>
                                <span className="ml-1 text-gray-600 text-sm">selected</span>
                            </div>

                            {/* Divider (Hidden on small screens) */}
                            <div className="hidden md:block w-px bg-slate-300 h-6"></div>

                            {/* Bulk Label Button */}
                            <button disabled={loadingData || multipleId?.length === 0} onClick={handleBulkLabelDownload} className={`flex items-center shadow-md rounded-lg ${loadingData || multipleId?.length === 0 ? 'bg-slate-400 cursor-not-allowed' : 'bg-slate-800'}  px-4 py-1.5 text-sm font-medium text-white transition`}>
                                <FaUpload className="mr-2 text-white" />
                                Bulk Label <span className="ms-2">{loadingData && <SpinLoader className="w-2 h-2" />}</span>

                            </button>
                        </div>
                    </div>
                    <div className="mt-2 bg-white p-4 border rounded-lg  ">
                        <Table
                            columns={orderTableColumns}
                            data={orderData || []}
                            currentPage={page}
                            totalRecords={GetOrderOrder?.getOrders?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            handlePagination={handlePagination}
                            multiSelectRow={onSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                        />
                    </div>



                </div>
            </div>
        </>
    )
}

export default DashShipment
